<create-group [categories]="images" [allowSort]="authenticationService.user.role>99"></create-group>
